var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 121,
    viewBox: "0 0 120 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2_422)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.007,
    y: 13.953,
    width: 83.993,
    height: 83.993,
    rx: 41.9965,
    fill: "#B80D20"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.4116 82.5669C73.7854 82.5669 85.4376 70.9147 85.4376 56.5409C85.4376 42.1671 73.7854 30.5149 59.4116 30.5149C45.0379 30.5149 33.3856 42.1671 33.3856 56.5409C33.3856 70.9147 45.0379 82.5669 59.4116 82.5669Z",
    fill: "#FF0420"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8228 63.4535C50.2716 63.4535 49.0015 63.0891 48.0125 62.3604C47.034 61.6213 46.5447 60.5594 46.5447 59.1956C46.5447 58.9041 46.5759 58.5606 46.6384 58.1442C46.8049 57.2072 47.0444 56.0829 47.3567 54.7608C48.2416 51.1796 50.5319 49.389 54.2171 49.389C55.2165 49.389 56.1222 49.5556 56.9134 49.8991C57.7046 50.2219 58.3293 50.7216 58.7873 51.3878C59.2454 52.0437 59.4744 52.8245 59.4744 53.7302C59.4744 54.0008 59.4432 54.3444 59.3807 54.7608C59.1829 55.9164 58.9539 57.0511 58.6728 58.1442C58.2147 59.9244 57.434 61.2673 56.3096 62.1522C55.1957 63.0267 53.6966 63.4535 51.8228 63.4535ZM52.1038 60.6427C52.8326 60.6427 53.4468 60.4241 53.9569 59.9972C54.4774 59.5704 54.8522 58.9146 55.0708 58.0193C55.3727 56.7908 55.6017 55.729 55.7579 54.8129C55.8099 54.5422 55.8412 54.2611 55.8412 53.9696C55.8412 52.7828 55.227 52.1894 53.9881 52.1894C53.2594 52.1894 52.6348 52.4081 52.1142 52.8349C51.6041 53.2617 51.2398 53.9176 51.0211 54.8129C50.7817 55.6873 50.5527 56.7492 50.3132 58.0193C50.2612 58.2795 50.23 58.5502 50.23 58.8417C50.2195 60.0493 50.8546 60.6427 52.1038 60.6427Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3797 63.2659C60.234 63.2659 60.1299 63.2243 60.0466 63.1306C59.9841 63.0265 59.9633 62.912 59.9841 62.7766L62.6804 50.076C62.7012 49.9302 62.7741 49.8157 62.899 49.722C63.0136 49.6283 63.1385 49.5867 63.2738 49.5867H68.4686C69.9156 49.5867 71.0712 49.8886 71.9457 50.482C72.8306 51.0858 73.2782 51.9498 73.2782 53.0846C73.2782 53.4073 73.2366 53.7508 73.1637 54.1048C72.841 55.6039 72.1851 56.7074 71.1857 57.4257C70.2071 58.144 68.8642 58.498 67.1569 58.498H64.5231L63.6278 62.7766C63.5965 62.9224 63.5341 63.0369 63.4091 63.1306C63.2946 63.2243 63.1697 63.2659 63.0344 63.2659H60.3797ZM67.2922 55.8017C67.844 55.8017 68.3124 55.6559 68.7185 55.354C69.1349 55.0521 69.4055 54.6253 69.5409 54.0631C69.5825 53.8445 69.6033 53.6467 69.6033 53.4802C69.6033 53.1054 69.4888 52.8139 69.2702 52.6161C69.0516 52.4079 68.6664 52.3038 68.1355 52.3038H65.7931L65.054 55.8017H67.2922Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2_422",
    x: 0.261957,
    y: 0.940002,
    width: 119.483,
    height: 119.483,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.732
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.8725
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_422"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.3856,
    y: 30.5149,
    width: 52.052,
    height: 52.052,
    rx: 26.026,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOp);
export default __webpack_public_path__ + "static/media/op.8bfe8dd30d7a50eca5872af320818799.svg";
export { ForwardRef as ReactComponent };